// extracted by mini-css-extract-plugin
export default {"container":"ProfileLayout_container__zBQTZ","wrapper":"ProfileLayout_wrapper__OIn3k","sidebar":"ProfileLayout_sidebar__bhc1Y"};